import { FILLED_INPUT_CLASS, getDefaultInputStyle } from '../components/LiliFloatingLabel/consts';
import { twMerge } from 'tailwind-merge';

export const textInputStyle = (
  fontClass: string,
  value?: string | number | null,
  disabled?: boolean
) =>
  twMerge(
    getDefaultInputStyle(fontClass),
    value ? FILLED_INPUT_CLASS : '',
    value && disabled ? 'text-text-main-tertiary bg-surface-primary-bw-02' : '',
    'pr-[24px]'
  );
